export function formatNumber(value) {
  if (value === null || value === undefined) return "—";
  const num = Number(value || 0);
  return Number.isFinite(num) ? num.toLocaleString("ru-RU") : "—";
}

export function formatMoney(value) {
  if (value === null || value === undefined) return "—";
  return `${formatNumber(value)} ₽`;
}

export function formatPercent(value) {
  if (value === null || value === undefined) return "—";
  const num = Number(value || 0);
  if (!Number.isFinite(num)) return "—";
  if (num !== 0 && Math.abs(num) < 0.1) return `${num < 0 ? "-" : ""}<0.1%`;
  return `${Math.round(num * 10) / 10}%`;
}

export function formatSignedPercent(value) {
  if (value === null || value === undefined) return "—";
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  const sign = num >= 0 ? "+" : "";
  if (num !== 0 && Math.abs(num) < 0.1) return `${sign}<0.1%`;
  return `${sign}${Math.round(num * 10) / 10}%`;
}

export function formatDateTime(value) {
  if (!value) return "—";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("ru-RU");
}

export function formatShare(value, total) {
  const denominator = Number(total || 0);
  if (!denominator) return "—";
  return formatPercent((Number(value || 0) / denominator) * 100);
}

export function formatEta(seconds) {
  if (seconds === null || seconds === undefined) return "—";
  const num = Number(seconds);
  if (!Number.isFinite(num)) return "—";

  const total = Math.max(0, Math.floor(num));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}ч ${m}м`;
  if (m > 0) return `${m}м ${s}с`;
  return `${s}с`;
}
